/*    
<summary>
  This functional component "DiscountPopupHOC" provides props to the child component.
  1. State "showDiscountPopup" that manages the show/hide of pop up
  2. Function "discountToggleHandler" to toggle the show/hide popup state "showDiscountPopup"
  Developer:Aashish Singh, Created Date:29-August-2023
</summary>
<returns>Returns JSX</returns>
*/
import React, { useState } from "react";

const DiscountPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showDiscountPopup, setShowDiscountPopup] = useState<boolean>(false);

    const discountToggleHandler = () => {
      setShowDiscountPopup(!showDiscountPopup);
    };

    return (
      <Component
        showDiscountPopup={showDiscountPopup}
        discountToggleHandler={discountToggleHandler}
        {...props}
      />
    );
  };

export default DiscountPopupHOC;
